import React from 'react';
import './AlertModal.css';

export default function AlertModal({
  type,
  title,
  message,
  variant = 'info',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive,
  onClose,
  onConfirm,
  onCancel,
}) {
  const isConfirm = type === 'confirm';

  return (
    <div className="alert-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="alert-modal-title" aria-describedby="alert-modal-desc">
      <div className={`alert-modal alert-modal--${variant} ${destructive ? 'alert-modal--destructive' : ''}`}>
        <div className="alert-modal-header">
          <h2 id="alert-modal-title" className="alert-modal-title">{title}</h2>
          {!isConfirm && (
            <button type="button" className="alert-modal-close" onClick={onClose} aria-label="Close">
              ×
            </button>
          )}
        </div>
        <div id="alert-modal-desc" className="alert-modal-body">
          {message.split('\n').map((line, i) => (
            <p key={i} className="alert-modal-message">{line}</p>
          ))}
        </div>
        <div className="alert-modal-actions">
          {isConfirm ? (
            <>
              <button type="button" className="alert-modal-btn alert-modal-btn--secondary" onClick={onCancel}>
                {cancelLabel}
              </button>
              <button type="button" className={`alert-modal-btn alert-modal-btn--primary ${destructive ? 'alert-modal-btn--danger' : ''}`} onClick={onConfirm}>
                {confirmLabel}
              </button>
            </>
          ) : (
            <button type="button" className="alert-modal-btn alert-modal-btn--primary" onClick={onClose}>
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
